import { getSettingSDUICategoryPagePathNavigationPaths } from "@faire/retailer/settings/getSettingSDUICategoryPagePathNavigationPaths";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";

export const useIsSDUISeasonalHubPage = (): boolean => {
  const navigationPath = useCurrentNavigationPath();
  return getSettingSDUICategoryPagePathNavigationPaths().includes(
    navigationPath
  );
};
